import { fetchWithLoginRedirect } from "@/api/loginRedirect";
import { getCookie } from "@/utils/getCookie";
import { type ClientRequestOptions, hc } from "hono/client";
import type { AppType } from "v2-server";

// `VITE_API_V2_BASE` already includes `/v2/api`; strip it because hc<AppType>
// expects the root the Hono app is mounted on.
const apiRootUrl =
	(import.meta.env.VITE_API_V2_BASE as string | undefined)?.replace(
		/\/v2\/api\/?$/,
		"",
	) ?? "";

/** Options shared by every v2 `hc` client: Bearer from the cookie, re-login on 401. */
export const v2ClientOptions = {
	headers: () => ({
		Authorization: `Bearer ${getCookie("access_token")}`,
	}),
	fetch: fetchWithLoginRedirect,
} satisfies ClientRequestOptions;

export const apiClient = hc<AppType>(apiRootUrl, v2ClientOptions);
